import { axiosInstance } from 'boot/axios';
import { compensateTimeZoneOffsetForBackend } from 'src/utils/helpers.js';

export async function getCancelationServiceDate({ commit }, payload) {
  commit('setIsLoadingCancelationServiceDate', true);

  return axiosInstance
    .get(`CancellationServicePeriod/ValidateDate?date=${payload.toISOString()}`)
    .then((response) => {
      commit('setIsCancelationServiceActive', response.data);
    })
    .finally(() => {
      commit('setIsLoadingCancelationServiceDate', false);
    });
}

export function addNewInsuredPerson({ commit }, payload) {
  commit('addNewInsuredPerson', payload);
}
export function removeNewInsuredPerson({ commit }, payload) {
  commit('removeNewInsuredPerson', payload);
}
export function updateNewInsuredPerson({ commit }, payload) {
  commit('setNewInsuredPerson', payload);
}

export function updateFormProperty({ commit }, payload) {
  commit('setFormProperty', payload);
}

export function setShouldRefreshContracts({ commit }, payload) {
  commit('setShouldRefreshContracts', payload);
}

export async function updateStartDate({ commit, dispatch }, payload) {
  await dispatch('getCancelationServiceDate', compensateTimeZoneOffsetForBackend(new Date()));
  commit('setStartDate', payload);
}

export function clearNewInsuredPerson({ commit }) {
  commit('clearNewInsuredPerson');
}
export function setIsLoadingCancelationServiceDate({ commit }, payload) {
  commit('setIsLoadingCancelationServiceDate', payload);
}
export function setIsCancelationServiceActive({ commit }, payload) {
  commit('setIsCancelationServiceActive', payload);
}
export function updateSelectedAgreementId({ commit }, payload) {
  commit('setSelectedAgreementId', payload);
}
export function updateShouldResetSelectedAgreementId({ commit }, payload) {
  commit('setShouldResetSelectedAgreementId', payload);
}
export function updateMedicalSelectionForNewlyInsuredPerson({ commit }, payload) {
  commit('updateMedicalSelectionForNewlyInsuredPerson', payload);
}
export function setCoInsuredOnForms({ commit }) {
  commit('setCoInsuredOnForms');
}
export function updateIsBornRecently({ commit }, payload) {
  commit('updateIsBornRecently', payload);
}
export function setStartDateOfNewBorn({ commit }, payload) {
  commit('setStartDateOfNewBorn', payload);
}
